import React from 'react';

import { IconCheckRound } from '@/components/apps/ui/icon';

import theme from '@/styles/theme';

/**
 * isValid: item 별 유효 상태를 표시
 * children: validate명
 */
type Props = {
  isValid: boolean;
  children: React.ReactNode;
  styleWidthSize?: string;
};

export default function DescriptionPasswordItem({ isValid, children }: Props) {
  return (
    <span
      className={`inline-flex items-center gap-0.5 whitespace-nowrap text-left text-sm font-normal leading-[150%] ${
        isValid ? 'text-apps-coreProductSuccess01' : 'text-apps-coreGray02'
      }`}
    >
      {isValid ? (
        <IconCheckRound
          size={12}
          color={theme`colors.apps.coreProductSuccess01`}
        />
      ) : (
        <IconCheckRound size={12} opacity={0.5} />
      )}
      {children}
    </span>
  );
}
